<template>
  <div class="content">
    <div class="row">
      <div class="col-md-3">
        <div class="card">
          <img id="icon_card" src="/images/openBox.png" alt="Cart" />
          <div class="info">
            <p>Total para enviar hoje</p>
            <h3>{{ state.total_enviar }}</h3>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card">
          <img id="icon_card" src="/images/barcode.png" alt="Cart" />
          <div class="info">
            <p>Produtos bipagem</p>
            <h3>{{ state.produtos_bipagem }}</h3>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card">
          <img id="icon_card" src="/images/box.png" alt="Cart" />
          <div class="info">
            <p>Para embalar</p>
            <h3>{{ state.embalar }}</h3>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card">
          <img id="icon_card" src="/images/schedule.png" alt="Cart" />
          <div class="info">
            <p>Tarefas para hoje</p>
            <h3>{{ state.tarefas_hoje }}</h3>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-md-12">
        <div class="quad">
          <div class="row">
            <div class="col-md-6">
              <h2>Produtos</h2>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table table-hover">
              <thead style="background-color: #560382; color: #b8d941">
                <tr>
                  <th scope="col" class="text-center">Imagem</th>
                  <th scope="col" class="text-center">Nome</th>
                  <th scope="col" class="text-center">Preço</th>
                  <th scope="col" class="text-center">Tags</th>
                  <th scope="col" class="text-center">Visitas</th>
                  <th scope="col" class="text-center">Qtd Vendas</th>
                  <th scope="col" class="text-center">Conversão</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="produto in state.produtos" :key="produto.id">
                  <th scope="row" class="text-center">
                    <img :src="produto.thumbnail" class="img_produto" />
                  </th>
                  <td>{{ produto.title }}</td>
                  <td class="text-center">R$ {{ produto.preco }}</td>
                  <td class="text-center">
                    <img src="/img/full.png" v-if="produto.fulfillment" />
                    <img src="/img/flex.jpg" v-if="produto.flex" />
                  </td>
                  <td class="text-center">
                    {{ produto.visitas.original.total_visits }}
                  </td>
                  <td class="text-center">
                    {{ produto.sales }}
                  </td>
                  <td class="text-center">
                    {{
                      new Intl.NumberFormat("pt-BR", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }).format(
                        (parseInt(produto.sales) /
                          parseInt(produto.visitas.original.total_visits)) *
                          100
                      )
                    }}%
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import services from "../../services";
import { useStorage } from "vue3-storage";
export default {
  setup() {
    const storage = useStorage();
    var token = storage.getStorageSync("cliente_token");
    var cliente_id = storage.getStorageSync("cliente_id");
    var colaborador_id = storage.getStorageSync("colaborador_id");

    function diasPesquisa(dias) {
      console.log("diasPesquisa called with:", dias);
    }

    onMounted(() => {
      fetchTotalParaEnviarHoje();
      fetchProdutosBipagem();
      fetchParaEmbalar();
      fetchTarefasHoje();
    });

    const state = reactive({
      total_enviar: "-",
      produtos_bipagem: "-",
      embalar: "-",
      tarefas_hoje: "-",
    });

    async function fetchTarefasHoje() {
      try {
        const { data } = await services.tarefas.tarefasHoje({
          id: colaborador_id,
          token,
        });

        state.tarefas_hoje = data.length || 0;
      } catch (error) {
        console.error("Erro ao buscar tarefas hoje:", error);
        state.tarefas_hoje = "-";
      }
    }

    async function fetchTotalParaEnviarHoje() {
      try {
        const { data } = await services.vendas.pacotesDoDia({
          token,
        });
        state.total_enviar = data.length || 0;
      } catch (error) {
        console.error("Erro ao buscar total para enviar hoje:", error);
        state.total_enviar = "-";
      }
    }

    async function fetchProdutosBipagem() {
      try {
        const { data } = await services.vendas.pacotesDoDiaBipagem({
          token,
        });
        state.produtos_bipagem = data.length || 0;
      } catch (error) {
        console.error("Erro ao buscar produtos bipagem:", error);
        state.produtos_bipagem = "-";
      }
    }

    async function fetchParaEmbalar() {
      try {
        const { data } = await services.vendas.pacotesDoDiaEmbalar({
          token,
        });
        state.embalar = data.length || 0;
      } catch (error) {
        console.error("Erro ao buscar para embalar:", error);
        state.embalar = "-";
      }
    }

    function calcularQuantidadeVendida(orders) {
      return orders.reduce((total, order) => {
        const qtdPedido = order.order_items.reduce(
          (sum, item) => sum + item.quantity,
          0
        );
        return total + qtdPedido;
      }, 0);
    }

    return {
      state,
      diasPesquisa,
    };
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Quicksand:wght@300;400;500;600;700&display=swap");

.content {
  padding: 4rem;
}

.card {
  width: 100%;
  background: #ffffff;
  border-radius: 12px;
  height: 140px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px;
  border: solid 1px #0000000d;
}

.card #icon_card {
  width: 60px;
  height: 60px;
  margin-right: 15px;
  object-fit: contain;
}

.img_produto {
  width: 60px;
}

.info p {
  margin-bottom: 0;
  color: #787878;
  font-size: 18px;
  font-weight: 500;
  font-family: "Poppins", sans-serif;
}

.info h3 {
  margin-bottom: 0;
  color: #001942;
  font-size: 26px;
  font-weight: 700;
  font-family: "Poppins", sans-serif;
}

.coluna {
  width: 100%;
  background: #ffffff;
  border-radius: 12px;
  border: solid 1px #0000000d;
}

.coluna h2 {
  font-weight: 600;
  color: #001942;
  font-size: 24px;
  font-family: "Poppins", sans-serif;
  padding: 10px;
}

.coluna-itens {
  padding: 20px;
}

.item {
  display: flex;
  align-items: center;
  justify-content: start;
  width: 100%;
  margin-bottom: 2rem;
}

.info2 {
  margin-left: 15px;
}

.info2 p {
  margin-bottom: 0;
  color: #787878;
  font-size: 18px;
  font-weight: 500;
  font-family: "Poppins", sans-serif;
}

.info2 h3 {
  margin-bottom: 0;
  color: #001942;
  font-size: 26px;
  font-weight: 700;
  font-family: "Poppins", sans-serif;
}

.quad {
  width: 100%;
  background: #ffffff;
  border-radius: 12px;
  border: solid 1px #0000000d;
}

.quad h2 {
  font-weight: 600;
  color: #001942;
  font-size: 24px;
  font-family: "Poppins", sans-serif;
  padding: 10px;
  margin-bottom: 0;
}

.search {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 10px;
  margin-right: 10px;
  margin-bottom: 1rem;
}

.search input {
  width: 100%;
  border: none;
  outline: none;
  padding: 10px;
  border-radius: 0 45px 45px 0;
  background: #f4f7fe;
}

.search input::placeholder {
  color: #9d9d9d;
}

.search .btn_search {
  border: none;
  outline: none;
  padding: 10px;
  border-radius: 45px 0 0 45px;
  background: #f4f7fe;
  color: #9d9d9d;
}

.table {
  border-radius: 6px;
  font-family: "Poppins", sans-serif;
}
</style>
